module.exports = __webpack_public_path__ + "img/InfocertID.73af3db8.svg";